import { useState } from "react";
import { useSearchParams } from "react-router-dom";

export default function CustomSearch({ searchTypes, placeholder }) {
  const [searchParams, setSearchParams] = useSearchParams();
  const [keyWord, setKeyWord] = useState("");
  const [index, setIndex] = useState(0);

  const onChange = (e) => {
    e.preventDefault();
    const selectedType = searchTypes[index];
    const newKeyWord = e.target.value;
    const newLength = selectedType.length;
    if (newKeyWord.length === newLength) {
      searchParams.delete("page");
      searchParams.set(selectedType.slug, newKeyWord);
    }
    if (newKeyWord.length === 0) {
      searchParams.delete(selectedType.slug);
    }
    setKeyWord(newKeyWord);
    setSearchParams(searchParams);
  };

  const onSelect = (e) => {
    setKeyWord("");
    setSearchParams("");
    setIndex(parseInt(e.target.value));
  };

  return (
    <div className="input-group">
      <input
        type="search"
        className="form-control"
        placeholder={placeholder}
        aria-label="Text input with dropdown button"
        onChange={onChange}
        value={keyWord}
        maxLength={searchTypes[index].length}
      />
      <select
        className="form-select form-select-sm"
        aria-label=".form-select-sm example"
        onChange={onSelect}
      >
        {searchTypes.map((e, i) => (
          <option selected={i === index} value={i}>
            {e.name}
          </option>
        ))}
      </select>
    </div>
  );
}
